import styled from 'styled-components';

export const UserImageWrapper = styled.div`
  position: ${(props) => (props.desktop ? 'static' : 'absolute')};
  width: 100%;
  padding: 16px 12px;
  background-color: white;
  color: black;
  border-radius: 14px;
  left: 0;
  right: 0;
  bottom: 8px;
  min-height: 200px;
  max-height: auto;
  text-align: left;

  @media (max-width: 720px) {
    width: 96%;
    position: absolute;
    margin: auto;
    max-height: 300px;
  }
`;

export const ReviewCenter = styled.div`
  max-width: 540px;
  margin: 0 auto;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 0 14px;

  @media (max-width: 720px) {
    padding-bottom: 8px;
  }
`;
export const UserName = styled.div`
  display: flex;
  text-align: left;
  padding-left: 10px;
  font-size: 15px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  text-transform: capitalize;
  width: 100%;

  .name {
    padding-bottom: 4px;
  }
`;
export const UserRating = styled.div`
  margin-left: auto;
`;

export const LightFont = styled.div`
  font-size: 10px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 60%);
  padding-top: 2px;
`;

export const UserContentTitle = styled.div`
  font-weight: 600;
  color: rgb(0 0 0 / 87%);
  font-size: 14px;
  padding: 4px 0 10px;
  line-height: 22px;
  text-transform: capitalize;
`;

export const UserBody = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 80%);
  line-height: 20px;
  overflow-y: auto;
  max-height: 360px;
  display: ${(props) => (props.showMobileOnly ? 'none' : 'block')};
  transition: all 0.1s ease;

  .lineRestrict {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .fullContent {
    -webkit-line-clamp: inherit;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .readmoreStyle {
    color: #0066cc;
    font-weight: 600;
  }

  @media (max-width: 720px) {
    max-height: 120px;
    display: ${(props) => (props.showDesktopOnly ? 'none' : 'block')};
  }

  &::-webkit-scrollbar {
    width: 0;
    transition: all 0.3s ease;
    @media (max-width: 720px) {
      width: ${(props) => (props.showMobileOnly ? '2px' : '0')};
    }
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  &:hover {
    &::-webkit-scrollbar {
      width: 3px;

      @media (max-width: 720px) {
        width: 0;
      }
    }
  }

  .react_ProductReviewItem_show_more {
    color: #0066cc;
    font-weight: 600;
  }
`;

export const PopupHelpful = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  font-size: 14px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 70%);
`;

export const HelpfulCountDiv = styled.div`
  display: flex;
  align-items: center;
  opacity: 0.9;

  img {
    width: 18px;
    height: 18px;
  }

  .count {
    font-weight: 600;
  }
`;
